const MAP = {
  submitted: "bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-300",
  in_review: "bg-blue-100 text-blue-700 dark:bg-blue-950 dark:text-blue-300",
  interview: "bg-amber-100 text-amber-700 dark:bg-amber-950 dark:text-amber-300",
  accepted: "bg-emerald-100 text-emerald-700 dark:bg-emerald-950 dark:text-emerald-300",
  rejected: "bg-rose-100 text-rose-700 dark:bg-rose-950 dark:text-rose-300",
  paid: "bg-emerald-100 text-emerald-700 dark:bg-emerald-950 dark:text-emerald-300",
  pending: "bg-amber-100 text-amber-700 dark:bg-amber-950 dark:text-amber-300",
};
const LABEL = { submitted: "Submitted", in_review: "In Review", interview: "Interview", accepted: "Accepted", rejected: "Rejected", paid: "Paid", pending: "Payment Pending" };

export function StatusBadge({ status }) {
  return (
    <span data-testid={`status-badge-${status}`}
      className={`inline-flex rounded-full px-2.5 py-0.5 text-xs font-semibold ${MAP[status] || MAP.submitted}`}>
      {LABEL[status] || status}
    </span>
  );
}
